module Meevo.Plugins.Register {
    export enum RegisterModalTypeEnum {
        ChangeDue = 0,
        Receipt = 1,
        Tip = 2,
        TipChangeDue = 3,
        TipChangeDueTransactionEditor = 4,
        Rebook = 5,
        TipEntry = 6,
        SignatureEntry = 7,
        TipCardOnFile = 8,
        TipCreditCard = 9,
        SaleNote = 10,
        PaymentPlanNote = 11
    }

    export abstract class ModalContextBase {
        constructor(protected parent: ModalController) {
        }

        load(...args: any[]) {
        }
    }

    export class ModalController {
        static $inject = [
            'registerContext',
            'modalType',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            '$mdToast',
            '$translate',
            '$q',
            '$timeout',
            '$mdDialog',
            '$locale',
            '$filter',
            'meevo.plugins.register.RegisterTipService',
        ];

        constructor(
            public registerContext: RegisterContext,
            public modalType: RegisterModalTypeEnum,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public modalService: Meevo.Components.Modal.IModalService,
            public $mdToast: angular.material.IToastService,
            public $translate: angular.translate.ITranslateService,
            public $q: angular.IQService,
            public $timeout,
            public $mdDialog: angular.material.IDialogService,
            public $locale: angular.ILocaleService,
            public $filter: angular.IFilterService,
            public registerTipService: Meevo.Plugins.Register.RegisterTipService
        ) {
            this.switchModalType(modalType);

            if (modalType === RegisterModalTypeEnum.ChangeDue) {
                this.registerContext.isTippyKioskMode().then(isKioskMode => this.hideAddTips = isKioskMode);
            }
        }

        //registerButtonHeight: any;
        context: ModalContextBase;
        toast;
        hideAddTips: boolean;
        SignatureEntryMethodEnum = Model.SignatureEntryMethodEnum;

        switchModalType(modalType) {
            switch (modalType) {
                case RegisterModalTypeEnum.Receipt:
                    if (this.registerContext.selectedDrawer.receiptTypeEnum !== Model.RegisterReceiptTypeEnum.PromptReceipt &&
                        (this.registerContext.selectedDrawer.receiptTypeEnum !== Model.RegisterReceiptTypeEnum.EmailReceipt || this.registerContext.isEmailEnabled)) {
                        this.registerContext.closeModal(this.registerContext.selectedDrawer.receiptTypeEnum);
                    }
                    break;

                case RegisterModalTypeEnum.Tip:
                case RegisterModalTypeEnum.TipCardOnFile:
                case RegisterModalTypeEnum.TipCreditCard:
                case RegisterModalTypeEnum.TipChangeDue:
                case RegisterModalTypeEnum.TipChangeDueTransactionEditor:
                    this.context = new TipModalContext(this);
                    this.context.load(this.registerContext.sale);
                    break;

                case RegisterModalTypeEnum.ChangeDue:
                    if (this.isExcessClientAccountPayment()) {
                        this.showToast();
                    }
                    break;
            }

            if (this.registerContext.setChangeDueAsCash) {
                this.registerContext.setChangeDueAsCash = false;
            }

            this.modalType = modalType;
        }

        private showToast() {
            if (this.isModalLoaded()) {
                let toast = this.$mdToast.simple();
                toast.theme("error-toast");
                toast.textContent(this.$translate.instant("MESSAGE_CLIENT_ACCOUNT_CHARGES_EXCEED_TOTAL"));
                toast.position("bottom right");
                toast.parent(angular.element(".checkout-content"));
                toast.hideDelay(0);

                this.$mdToast.show(toast);
            } else {
                this.$timeout(200).then(() => this.showToast());
            }
        }

        private isModalLoaded() {
            return angular.element(".checkout-content").length > 0;
        }

        canFinalize() {
            return this.registerContext.canFinalize();
        }

        closeChangeDue() {
            if (this.isExcessClientAccountPayment()) {
                return;
            }

            this.closeModal();
            this.registerContext.checkoutHandleReceipt();
        }

        private isExcessClientAccountPayment() {
            let clientAccountPaymentsTotal = 0;
            _(this.registerContext.sale.paymentLines).where({ paymentCategory: Model.PaymentCategoryEnum.ClientAccount }).forEach((clientAccountPayment) => {
                clientAccountPaymentsTotal += clientAccountPayment.amount;
            });

            return clientAccountPaymentsTotal > 0 && clientAccountPaymentsTotal > this.registerContext.sale.total;
        }

        isTip() {
            return this.modalType === RegisterModalTypeEnum.Tip || this.modalType === RegisterModalTypeEnum.TipCardOnFile || this.modalType === RegisterModalTypeEnum.TipCreditCard;
        }

        isTipChangeDue() {
            return this.modalType === RegisterModalTypeEnum.TipChangeDue || this.modalType === RegisterModalTypeEnum.TipChangeDueTransactionEditor;
        }

        isChangeDue() {
            return this.modalType === RegisterModalTypeEnum.ChangeDue;
        }

        isReceipt() {
            return this.modalType === RegisterModalTypeEnum.Receipt;
        }

        isRebook() {
            return this.modalType === RegisterModalTypeEnum.Rebook;
        }

        isTipEntry() {
            return this.modalType === RegisterModalTypeEnum.TipEntry;
        }

        isSignatureEntry() {
            return this.modalType === RegisterModalTypeEnum.SignatureEntry;
        }

        closeTipEntryModal(response) {
            this.$mdDialog.hide(response);
        }

        closeSignatureEntryModal(response) {
            this.$mdDialog.hide(response);
        }

        closeModal(cancel: boolean = false): angular.IPromise<any> {
            if (this.modalType === RegisterModalTypeEnum.TipChangeDue) {
                this.switchModalType(RegisterModalTypeEnum.ChangeDue);
                return this.$q.resolve();
            } else
            {
                if (cancel) {
                    this.$mdDialog.cancel();
                    return this.$q.reject();
                } else {
                    return this.registerContext.closeModal();
                }
            }
        }

        backToSale() {
            if (this.registerContext.setChangeDueAsCash) {
                this.registerContext.setChangeDueAsCash = false;
            }
            this.closeModal().then(() => {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
                this.registerContext.backToSale();
            });
        }

        saveSaleNote(note: string, isChecked: boolean) {
            this.registerContext.saveSaleNote(note, isChecked);
            this.closeModal();
        }

        isSignatureTerminalVisible(): boolean {
            return this.registerContext &&
                   this.registerContext.selectedMerchantAccount &&
                   this.registerContext.selectedMerchantAccount.hasTerminalSignatureCaptureSupport;
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.ModalController", ModalController);
}